<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import MobileAppFormCompletion from "@/components/forms/MobileAppFormCompletion.vue";
import ArrowLeft from "@/components/shared/icons/ArrowLeft.vue";
import { FORMS_SUBMISSIONS } from "@/constants.js";

defineOptions({
  name: "TranscriptReleaseForm",
});

const route = useRoute();
const applicationId = computed(() => route.params?.applicationId);
</script>

<template>
  <div class="w-full px-4 pb-4 mx-auto max-w-7xl sm:px-8 sm:pb-8">
    <div class="my-4">
      <router-link
        class="inline-flex items-center text-sm text-gray-700 hover:text-gray-700 hover:underline"
        :to="{
          name: 'applications/landing',
          params: { applicationId },
        }"
      >
        <ArrowLeft custom-class="w-4 h-4" />
        <span class="ml-1">Back</span>
      </router-link>
    </div>
    <div>
      <h1 id="participant" class="font-montserrat text-2xl font-bold text-university-primary">
        {{ FORMS_SUBMISSIONS.transcriptRelease.name }}
      </h1>
      <MobileAppFormCompletion :form-label="FORMS_SUBMISSIONS.transcriptRelease.name" />
    </div>
  </div>
</template>
